import React from 'react';
import Image, { ImageProps } from 'components/commercetools-ui/atoms/image';
import Typography from 'components/commercetools-ui/atoms/typography';

export interface FeatureItem {
  icon: ImageProps;
  description: string;
}

export interface FeatureListProps {
  title: string;
  featureItems: FeatureItem[];
}

const FeatureList: React.FC<FeatureListProps> = ({ title, featureItems }) => {
  return (
    <div className="py-32 md:py-64">
      <div className="container mx-auto">
        <Typography as="h2" className="body-text-2xlarge mb-32 font-medium">
          {title}
        </Typography>

        <div className="grid grid-cols-1 gap-16 md:grid-cols-2 lg:grid-cols-3">
          {featureItems?.map((item, index) => (
            <div key={`feature-${index}`} className="flex items-center">
              <div className="mr-16 flex-shrink-0">
                <Image media={item.icon.media} src={item.icon.src} alt={item.description} width={48} height={48} />
              </div>
              <Typography className="body-text">{item.description}</Typography>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureList;
